/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_NotesInputs */



/**
* | output |
* | --- |
* | "Release Notes" |
*
* @param {Release_NotesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const release_notes = /** @type {((inputs?: Release_NotesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_NotesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notes de version")
	if (locale === "de") return /** @type {LocalizedString} */ ("Versionshinweise")
	if (locale === "it") return /** @type {LocalizedString} */ ("Note di rilascio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примечания к выпуску")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notas de la versión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发行说明")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リリースノート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिलीज नोट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notas de lançamento")
	return /** @type {LocalizedString} */ ("Release Notes")
});